import Header from '../components/Header';
import Footer from '../components/Footer';

const Layout = ({title, children }) => {
  return (
    <>
      <div className="min-h-full dark:bg-gray-900">
        <Header title={title}/>
        <main className="-mt-32">
          <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
              {children}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Layout;


